import type { FC } from 'react'
import { memo } from 'react'

import CommonButtons from './components/commonButtons'
import DetailsButton from './components/detailsButton'
import SuggestMetricsButton from './components/suggestMetricsButton'
import Toolbar from './components/toolbar'

import type { DomainNode } from '@app/types'

interface Props {
  node: DomainNode
}

const MetricToolbar: FC<Props> = ({ node }) => {
  const { strategyId } = node
  const route = `/strategy/${strategyId}/map/metric/${node.data.id}`

  return (
    <Toolbar strategyId={strategyId}>
      <DetailsButton path={route} />
      <SuggestMetricsButton strategyId={strategyId} metricId={node.data.id} />
      <CommonButtons node={node} />
    </Toolbar>
  )
}

export default memo(MetricToolbar)
